<template>
    <BreadCrumb PageTitle="Liste des inscriptions" />
    <ListeInscription/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
   import ListeInscription from "@/components/Inscription/ListeInscription.vue";
  
    export default defineComponent({
      name: "ListeInscriptionPage",
      components: {
        BreadCrumb,
        ListeInscription,
      },
    });
  </script>